import React from 'react';
import { Container } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import UserProfile from '../components/UserProfile';
import { isAdminSession } from '../../../shared/auth/session';

export default function UserProfilePage() {
  const isAdmin = isAdminSession();

  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <UserProfile
          title={isAdmin ? 'Perfil de administrador' : 'Perfil de usuario'}
          subtitle={isAdmin ? 'Gestiona tu información de acceso y mantén tus credenciales actualizadas desde esta pantalla.' : 'Revisa y actualiza tus datos personales y credenciales desde una sola vista.'}
          redirectTo={isAdmin ? '/homeAdmin' : '/home'}
          allowProfessionEdit={!isAdmin}
        />
      </Container>
    </DashboardLayout>
  );
}
